import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import List from '@material-ui/core/List';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import BounceButton from '../bounceButton.container';
import EditSessionButtonContainer from '../editSessionButton.component';
import ToggleActiveFileButtonContainer from '../toggleActveFileButton.container';
import DownloadContainer from '../download.container';
import { Icon, Dialog, DialogTitle, DialogContent, TextField } from '@material-ui/core';
import { connect } from 'react-redux';
import {updateFileName} from '../../../../store/actions/session.actions'

const styles = theme => ({
  list: {
    width: '200px',
  },
  lastactiverow: {
    backgroundColor: '#f3f3f3',
  },
  icon: {
    marginRight: theme.spacing.unit
  },
  text: {
    textTransform: 'unset'
  }
});

class SessionTableRowComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleDialog = this.handleDialog.bind(this);
    this.cancel = this.cancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateName = this.updateName.bind(this);
    this.state = {
      open: false,
      openDialog: false,
      name: props.row.displayname
    };
  }

  handleClick() {
    this.setState(state => ({ open: !state.open }));
  }
  handleDialog() {
    this.setState(state => ({ openDialog: !state.openDialog }));
  }
  updateName(e) {
    e.preventDefault();
    this.props.updateFileName(this.props.sessionId, this.props.row.id, this.state.name)
    this.handleDialog();

  }
  cancel() {
    this.handleDialog();
  }
  handleChange(e) {

    this.setState({ name: e.target.value });

  }
  render() {
    const { sessionId, row, classes } = this.props;


    return (
      <TableRow
        hover
        tabIndex={-1}
        className={this.props.rowLastActive ? classes.lastactiverow : ''}
      >
        <TableCell>
          <Button color="primary" className={classes.text} onClick={this.handleDialog}>
          <Icon  className={classes.icon}>edit</Icon>
          {row.displayname}
          </Button>

        </TableCell>
        <TableCell>{moment(row.lastModified).format('DD-MM-YYYY HH:mm')}</TableCell>
        <TableCell>
          <EditSessionButtonContainer sessionId={sessionId} fileId={row.id} />
        </TableCell>
        <TableCell>
          <BounceButton
          sessionId={sessionId}
            fileId={row.id}
            disabled={false}>

            </BounceButton>
        </TableCell>
        <TableCell>
          <Button
            onClick={this.handleClick}
            color="primary"
          >
            {this.state.open
              ? <ExpandLess className={classes.downloadIcon} />
              : <ExpandMore className={classes.downloadIcon} />
            }
            Download File Type
          </Button>
          <Collapse in={this.state.open} timeout="auto" unmountOnExit>
            <List component="div" className={classes.list} disablePadding>
              <DownloadContainer
                buttonText="Conversion File"
                type="conversion"
                sessionId={sessionId}
                fileId={row.id}
              />
              <DownloadContainer
                buttonText="Attribute file"
                type="attribute"
                disabled={!row.savedByUser}
                sessionId={sessionId}
                fileId={row.id}
              />
              <DownloadContainer
                buttonText="Mapping file"
                type="mappingFile"
                disabled={!row.savedByUser}
                sessionId={sessionId}
                fileId={row.id}
              />
            </List>
          </Collapse>
        </TableCell>

        <TableCell>
          <ToggleActiveFileButtonContainer
            sessionId={sessionId}
            fileId={row.id}
            label="Delete"
            icon="delete"
          />
        </TableCell>
        <Dialog
          open={this.state.openDialog}
          onClose={this.toggle}
        >
          <DialogTitle>Change File Name</DialogTitle>
          <DialogContent className={this.props.classes.dialog}>
            <form onSubmit={this.updateName}>
              <TextField
                autoFocus
                className={classes.textField}
                value={this.state.name}
                onChange={this.handleChange}
                fullWidth
              />
              <Button className={classes.buttonLeft} onClick={this.cancel} color="primary">
                Cancel
              </Button>
              <Button type="submit" className={classes.buttonRight} color="primary">
                Save
              </Button>
            </form>
          </DialogContent>
        </Dialog>
      </TableRow>
    );
  }
}

SessionTableRowComponent.propTypes = {
  sessionId: PropTypes.string.isRequired,
  row: PropTypes.shape({
    id: PropTypes.string,
    filename: PropTypes.string,
    lastModified: PropTypes.number,
    savedByUser: PropTypes.bool,
    displayname: PropTypes.string,
  }).isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
  rowLastActive: PropTypes.bool.isRequired,
  updateFileName: PropTypes.func,
};

export default connect(null,{updateFileName})(withStyles(styles)(SessionTableRowComponent));
